import { render, staticRenderFns } from "./ReportSalesWholesalers.vue?vue&type=template&id=0b50e580&"
import script from "./ReportSalesWholesalers.vue?vue&type=script&lang=js&"
export * from "./ReportSalesWholesalers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
